import { render, staticRenderFns } from "./viewed.vue?vue&type=template&id=5d7bf65c"
import script from "./viewed.vue?vue&type=script&lang=ts"
export * from "./viewed.vue?vue&type=script&lang=ts"
import style0 from "./viewed.vue?vue&type=style&index=0&id=5d7bf65c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports